import { render } from "./klaviyo-bis-message.vue?vue&type=template&id=0175671e"
import script from "./klaviyo-bis-message.vue?vue&type=script&lang=js"
export * from "./klaviyo-bis-message.vue?vue&type=script&lang=js"

import "./klaviyo-bis-message.vue?vue&type=style&index=0&id=0175671e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__